<template>
  <FlugverfuegbarkeitenWidget
    :flugverfuegbarkeiten="params.value ?? []"
    :data="params.data"
    :excludeAirports="params.excludeAirports || []"
  ></FlugverfuegbarkeitenWidget>
</template>

<script>
import FlugverfuegbarkeitenWidget from '@/components/produkte/reisetermine/flugverfuegbarkeiten-widget.vue';

export default {
  components: { FlugverfuegbarkeitenWidget },
  mounted() {},
};
</script>
